import * as React from "react";
import { PoshSelectRadioListItem } from "../../../misc/components/PoshSelectListItem";
import { Subject } from "../../../misc/api/apiTypes";
import { Device } from "webportalclient";
import * as P230Messages from "../../../misc/api/DeviceLinkApi/P230In2itiveMessages";
import LoadingWithMessage from "../../../misc/components/LoadingWithMessage";
import { faDiary } from "@vitalograph/web-ui";
import { useWebPortalApiClient } from "../../../misc/api/WebPortalTokenClient";

interface RemoteDeviceSelectProps {
    subject: Subject;
    selectedDevice: Device;
    onSelect: (selectedDevice: Device) => void;
    onNext: () => void;
    onBack: () => void;
    onError: (message: string) => void;
}

export const RemoteDeviceSelect = ({
    subject,
    selectedDevice,
    onSelect,
    onNext,
    onBack,
    onError
}: RemoteDeviceSelectProps) => {
    const client = useWebPortalApiClient();
    const [allocations, setAllocations] = React.useState<Device[]>();

    React.useEffect(() => {
        const getData = async () => {
            const allocationResult = await client.client.getDevices(undefined, `allocatedSubjectId eq ${subject.Id}`);
            setAllocations(allocationResult.value);
            if (allocationResult["@odata.count"] === 0) {
                return onError(P230Messages.NoAllocationsForSubject);
            }

            if (allocationResult["@odata.count"] === 1) {
                onSelect(allocationResult.value[0]);
                onNext();
            }

        }

        getData();
    }, [client, subject]);

    if (!allocations)
        return (<LoadingWithMessage message="Loading Devices..." />);

    return (
        <>
            <div className="modal-body">
                <div className="row">
                    <div className="col-md-12">
                        <h2 className="text-primary">Device to Configure</h2>
                    </div>
                    <div className="col-md-12">
                        <ul className="posh-select">
                            {allocations.map(a => (
                                <PoshSelectRadioListItem
                                    key={a.id}
                                    id={a.id}
                                    title={a.serialNumber}
                                    description=""
                                    icon={faDiary}
                                    isChecked={a === selectedDevice}
                                    onChange={() => onSelect(a)}
                                />))}
                        </ul>
                    </div>
                </div>
            </div>
            <div className="modal-footer">
                <button className="btn btn-primary" disabled={!selectedDevice} onClick={onNext}>Next</button>
                <button className="btn btn-primary btn-outline" onClick={onBack}>Back</button>
            </div>
        </>
    );
};
